import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home, ArrowLeft, Search } from 'lucide-react'

function NotFoundPage() {
  const location = useLocation()
  useEffect(() => {
    // #region agent log
    fetch('http://127.0.0.1:7730/ingest/40704d02-ed97-4c5f-9aec-31ab7628389e', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': 'eb7a95' },
      body: JSON.stringify({
        sessionId: 'eb7a95',
        location: 'NotFoundPage.jsx:useEffect',
        message: 'NotFound rendered',
        data: {
          pathname: location.pathname,
          hypothesisId: 'H1',
          /** H1: /admin/setup-behavior without :userId does not match any Route */
          isSetupBehaviorMissingUserId:
            /^\/admin\/setup-behavior\/?$/.test(location.pathname) === true,
        },
        timestamp: Date.now(),
        runId: 'pre-fix',
      }),
    }).catch(() => {})
    // #endregion
  }, [location.pathname])

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-gradient-to-br from-primary-50 to-accent-50">
      {/* Background Effects */}
      <div className="fixed top-1/3 left-1/4 w-96 h-96 bg-primary-200/30 rounded-full blur-3xl" />
      <div className="fixed bottom-1/3 right-1/4 w-96 h-96 bg-accent-200/30 rounded-full blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative text-center max-w-lg"
      >
        {/* 404 Text */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, type: 'spring' }}
          className="mb-8"
        >
          <span className="text-[10rem] font-bold leading-none gradient-text">
            404
          </span>
        </motion.div>

        {/* Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring' }}
          className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-primary flex items-center justify-center shadow-glow"
        >
          <Search className="w-10 h-10 text-white" />
        </motion.div>

        {/* Message */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h1>
          <p className="text-gray-500 mb-8">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>
        </motion.div>

        {/* Actions */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link to="/" className="btn-primary flex items-center gap-2">
            <Home className="w-5 h-5" />
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="btn-secondary flex items-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Go Back
          </button>
        </motion.div>

        {/* Helpful Links */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-12 pt-8 border-t border-gray-200"
        >
          <p className="text-sm text-gray-400 mb-4">Here are some helpful links:</p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
            <Link
              to="/dashboard"
              className="text-primary-600 hover:text-primary-700 transition-colors"
            >
              Dashboard
            </Link>
            <span className="text-gray-300">•</span>
            <Link
              to="/calendar"
              className="text-primary-600 hover:text-primary-700 transition-colors"
            >
              Calendar
            </Link>
            <span className="text-gray-300">•</span>
            <Link
              to="/settings"
              className="text-primary-600 hover:text-primary-700 transition-colors"
            >
              Settings
            </Link>
          </div>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default NotFoundPage
